import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Field,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Select,
  Spinner,
} from "../../../design-system";
import { reportWorkdayIncident } from "../../../helpers/kronaly_helper";

const INCIDENT_TYPES = [
  { value: "meeting_in_progress", label: "Reunión en curso" },
  { value: "client_call", label: "Llamada con cliente" },
  { value: "travel", label: "Desplazamiento" },
  { value: "technical_issue", label: "Problema técnico" },
  { value: "urgent_task", label: "Tarea urgente no planificada" },
  { value: "manager_instruction", label: "Instrucción de un responsable" },
  { value: "cannot_leave_post", label: "Imposibilidad de abandonar el puesto" },
  { value: "other", label: "Otro motivo" },
];

const ReportIncidentModal = ({ open, employeeProfileId, onClose, onCreated }) => {
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setType("");
      setDescription("");
      setError(null);
    }
  }, [open]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!employeeProfileId) {
      setError("No se pudo determinar tu ficha de empleado en este workspace.");
      return;
    }
    if (!type) {
      setError("Selecciona el tipo de incidencia.");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const payload = {
        employee_profile_id: employeeProfileId,
        type,
      };
      if (description.trim()) payload.description = description.trim();
      const r = await reportWorkdayIncident(payload);
      onCreated?.(r?.data ?? r);
      onClose();
    } catch (err) {
      setError(typeof err === "string" ? err : err?.message || "No se pudo registrar la incidencia.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Registrar incidencia de jornada" size="md">
      <form onSubmit={onSubmit}>
        <ModalBody>
          {error && <div className="kr-mb-3"><Alert tone="danger">{error}</Alert></div>}
          <p className="kr-text-muted kr-fs-12 kr-mb-4">
            Si no puede finalizar su jornada en este momento, indique el motivo.
            La incidencia quedará registrada y será validada por su responsable.
          </p>

          <Field label="Tipo de incidencia" style={{ marginBottom: 12 }}>
            <Select value={type} onChange={(e) => setType(e.target.value)} required>
              <option value="">Seleccionar...</option>
              {INCIDENT_TYPES.map((t) => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </Select>
          </Field>

          <Field label="Descripción (opcional)">
            <Input
              type="textarea"
              rows={3}
              maxLength={2000}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Detalle la situación que le impide finalizar"
            />
          </Field>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving && <Spinner size={12} color="#fff" />}
            Registrar incidencia
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default ReportIncidentModal;
